const MS_PER_DAY = 86_400_000;

export type PostableClipExpiryFields = {
  finished_video_url?: string | null;
  createdAt?: string | null;
  clipping_status?: string | null;
  preparing_status?: string | null;
  rendering_status?: string | null;
  processing_status?: string | null;
};

export function hasExpiredClipStatus(clip: PostableClipExpiryFields): boolean {
  return clip.clipping_status === 'expired'
    || clip.preparing_status === 'expired'
    || clip.rendering_status === 'expired'
    || clip.processing_status === 'expired';
}

/** A clip the calendar can actually send: rendered file still present and not past plan expiry. */
export function isPostableClip(
  clip: PostableClipExpiryFields,
  { maxExpiryDays, now }: { maxExpiryDays: number | null; now: Date },
): boolean {
  if (!clip.finished_video_url) return false;
  if (hasExpiredClipStatus(clip)) return false;
  if (!maxExpiryDays || !clip.createdAt) return true;
  const createdMs = Date.parse(clip.createdAt);
  if (!Number.isFinite(createdMs)) return true;
  const ageDays = (now.getTime() - createdMs) / MS_PER_DAY;
  return ageDays <= maxExpiryDays;
}

export function resolveMaxExpiryDays({
  subscription,
  plans,
}: {
  subscription?: {
    max_expiry_days?: number | null;
    plan?: {
      max_expiry_days?: number | null;
      name?: string | null;
      slug?: string | null;
    } | null;
  } | null;
  plans?: Array<{
    name?: string | null;
    slug?: string | null;
    max_expiry_days?: number | null;
  }>;
}): number | null {
  const direct = subscription?.max_expiry_days ?? subscription?.plan?.max_expiry_days;
  if (typeof direct === 'number' && direct > 0) return direct;
  const name = subscription?.plan?.name;
  const slug = subscription?.plan?.slug;
  const match = (plans ?? []).find((plan) => (
    (!!name && plan.name === name) || (!!slug && plan.slug === slug)
  ));
  const fromPlan = match?.max_expiry_days;
  return typeof fromPlan === 'number' && fromPlan > 0 ? fromPlan : null;
}
